module.exports = __webpack_public_path__ + "img/table-icon-telegram.4e27b3c3.png";